import { Component, OnInit, inject } from '@angular/core';
import { OverlayPopupRef , MAT_OVERLAY_DATA} from '../../core';

@Component({
    selector: 'app-description-overlay',
    templateUrl: './description-overlay.component.html',
    styleUrls: ['./description-overlay.component.scss']
})
export class DescriptionOverlayComponent implements OnInit {
  dialogRef = inject<OverlayPopupRef<DescriptionOverlayComponent>>(OverlayPopupRef);
  inputdata = inject<[
]>(MAT_OVERLAY_DATA);

  testsystem: any;
  
  ngOnInit(): void {
    this.testsystem = this.inputdata;
  }
}